import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import "./SFGstore.css";
import dayjs from "dayjs";
import SearchIcon from "@mui/icons-material/Search";
import { getSFGBoxRetrivalHistory } from "./services"; // Import the correct service function

const RetrieveHistory = () => {
  const navigate = useNavigate();
  const [startDateReFormat, setStartDateReFormat] = useState(null);
  const [endDateReFormat, setEndDateReFormat] = useState(null);
  const [debouncedSearchText, setDebouncedSearchText] = useState({});
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [SFGStoreDetails, setSFGStoreDetails] = useState([]);
  const [totalCount, setTotalCount] = useState();

  const initiallValue = {
    Date: "",
    batch__batch_type: "",
    aging: "",
    box_no: "",
    class_id__class_name: "",
    lot_no: "",
    size__size_name: "",
    length__length: "",
    scre_type: "",
    quantity: "",
    rack_id: "",
    user: "",
    sfg_label:""
  };

  const [searchText, setSearchText] = useState(initiallValue);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchText(searchText); // Update the debounced searchText
    }, 500); // 500ms debounce delay

    return () => {
      clearTimeout(handler); // Cleanup the timeout
    };
  }, [searchText]); // Effect runs when searchText changes

  const handleSearchData = (e) => {
    const { name, value } = e.target;
    setSearchText({ ...searchText, [name]: value });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const dateFormat = "YYYY-MM-DD HH:mm:ss";
  const formatStartDate = startDateReFormat
    ? dayjs(startDateReFormat).format(dateFormat)
    : "";
  const formatEndDate = endDateReFormat
    ? dayjs(endDateReFormat).format(dateFormat)
    : "";

  const fetchRetrievalHistory = async (sfgBoxId = null) => {
    const queryParams = {
      quantity__icontains: debouncedSearchText.quantity || null,
      created_by__username__icontains: debouncedSearchText.user || null,
      'sfg_box_no__sfg_box_no__class_id__class_name': debouncedSearchText.class || null,
      'sfg_box_no__sfg_box_no__size__size_name__icontains': debouncedSearchText.size || null,
      'sfg_box_no__sfg_box_no__length__length__icontains': debouncedSearchText.length || null,
      'sfg_box_no__sfg_box_no__scre_type__cuff_name__icontains': debouncedSearchText.cuff || null,
      'sfg_box_no__sfg_box_no__lot_no__icontains': debouncedSearchText.lot_no || null,
      'sfg_box_no__sfg_box_no__gloves_type__pairing_gloves_type_name__icontains': debouncedSearchText.type || null,
      'sfg_box_no__sfg_box_no__box_no__icontains': debouncedSearchText.box_no || null,
      'sfg_box_no__sfg_box_no__sfg_label__icontains': debouncedSearchText.sfg_label || null,
      created_at: debouncedSearchText.Date || null,
      rack_id :debouncedSearchText.rack_id || null,
      page: page + 1,
      page_size: rowsPerPage,
    };
  
    if (sfgBoxId) {
      queryParams.sfg_box_id = sfgBoxId;
    }

    const filteredParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== '')
    );
  
    try {
      const response = await getSFGBoxRetrivalHistory({ params: filteredParams });
      if (response.data.results.success) {
        setSFGStoreDetails(response.data.results.payload);
        setTotalCount(response.data.count);
      }
    } catch (error) {
      setSFGStoreDetails([]);
      console.error("Failed to fetch retrieval history:", error);
    }
  };

  useEffect(() => {
    if (Object.keys(debouncedSearchText).length > 0) {
      fetchRetrievalHistory();
    }
  }, [debouncedSearchText, page, rowsPerPage]);

  return (
    <div className="dashboard-wrapper page-wraper">
      <div className="page-header">
        <div
          className="page-back-btn"
          onClick={() => navigate(-1)}
          style={{ cursor: "pointer" }}
        >
          <ArrowBackIcon />
          <span>Retrive History</span>
        </div>
      </div>
      <div className="pt-3 table-responsive">
        <TableContainer component={Paper}>
          <Table
            aria-label="Dipping parameter"
            className="dipping-params sfg-score-table"
          >
            <TableHead>
              <TableRow>
                <TableCell>Label No.</TableCell>
                <TableCell>Date and Time</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Class</TableCell>
                <TableCell>Size</TableCell>
                <TableCell>Length</TableCell>
                <TableCell>Cuff</TableCell>
                <TableCell>Lot No</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Box No.</TableCell>
                <TableCell>Rack Id</TableCell>
                <TableCell>User</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Label No."
                    name="box_no"
                    value={searchText.box_no}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Date and Time"
                    name="Date"
                    value={searchText.Date}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Type"
                    name="type"
                    value={searchText.type}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Class"
                    name="class"
                    value={searchText.class}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Size"
                    name="size"
                    value={searchText.size}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Length"
                    name="length"
                    value={searchText.length}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Cuff"
                    name="cuff"
                    value={searchText.cuff}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Lot No"
                    name="lot_no"
                    value={searchText.lot_no}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Quantity"
                    name="quantity"
                    value={searchText.quantity}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Box No."
                    name="sfg_label"
                    value={searchText.sfg_label}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Rack Id"
                    name="rack_id"
                    value={searchText.rack_id}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="User"
                    name="user"
                    value={searchText.user}
                    onChange={handleSearchData}
                  />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {SFGStoreDetails &&
                SFGStoreDetails.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row.box_no}</TableCell>
                    <TableCell>{row.created_at ? dayjs(row.created_at).format("YYYY-MM-DD HH:mm:ss") :""}</TableCell>
                    <TableCell>{row.gloves_type}</TableCell>
                    <TableCell>{row.class_name}</TableCell>
                    <TableCell>{row.size_name}</TableCell>
                    <TableCell>{row.length}</TableCell>
                    <TableCell>{row.cuff}</TableCell>
                    <TableCell>{row.lot_no}</TableCell>
                    <TableCell>{row.quantity}</TableCell>
                    <TableCell>{row.sfg_label}</TableCell>
                    <TableCell>{row.rack_id}</TableCell>
                    <TableCell>{row.created_by}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <TablePagination
        className="table-pagination"
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={totalCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default RetrieveHistory;